import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import useCustomizerStore from "../../../state/customizer";
import useTransitionStore from "../../../state/transitions";

export const ScrollContainer = () => {
  const [touchStart, setTouchStart] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const model = useCustomizerStore((s) => s.model);
  const setModel = useCustomizerStore((s) => s.setModel);
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);

  const transitioningRef = useRef(false);

  useEffect(() => {
    if (isTransitioning) {
      setTimeout(() => {
        setIsTransitioning(false);
        transitioningRef.current = false;
      }, 2000);
    }
  }, [isTransitioning]);

  return (
    <Div
      onTouchStart={(e) => {
        if (DisplayMode !== "flipper") return;
        // console.log(e.touches[0].clientY);

        setTouchStart(e.touches[0].clientY);
      }}
      onTouchEnd={(e) => {
        if (DisplayMode === "flipper") {
          if (e.changedTouches[0].clientY < touchStart) {
            if (model < 2) {
              setModel(model + 1);
            } else {
              setModel(0);
            }
          } else if (e.changedTouches[0].clientY > touchStart) {
            if (model > 0) {
              setModel(model - 1);
            } else {
              setModel(2);
            }
          }
        }
      }}
      onWheel={(e) => {
        if (transitioningRef.current) return;
        if (!isTransitioning) {
          transitioningRef.current = true;
          setIsTransitioning(true);
          if (DisplayMode === "flipper") {
            if (e.deltaY > 0) {
              if (model < 2) {
                setModel(model + 1);
              } else {
                setModel(0);
              }
            } else if (e.deltaY < 0) {
              if (model > 0) {
                setModel(model - 1);
              } else {
                setModel(2);
              }
            }
          }
        }
      }}
    />
  );
};

const Div = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
